module.exports = __webpack_public_path__ + "static/debug-7849b246b5c6b4f2c422dff9f4ac602c.png";